import style from "./video-call-participants-chip.module.css";

export default function VideoCallParticipantsChip({ count }: { count: number }) {
  if (count > 0) {
    return <div className={style.videoCallParticipantsChip}>{count}</div>;
  }

  return null;
}
